import contains from './contains';
import values from './values';

export default (obj: object, value: any): boolean => contains(values(obj), value);
